import { OrderItem } from '../../types';
import { filterCarcaseItems } from './filterCarcaseItems';
import { getAllOrderItemsTotal } from './getAllOrderItemsTotal';

export function getCarcaseItemsTotal(orderItems : OrderItem[]) : string {

    return getAllOrderItemsTotal(filterCarcaseItems(orderItems));

}
